import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { SdSwiperComponent } from '@sdvor/shared/ui';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { MediaModule, PageComponentModule } from '@spartacus/storefront';
import { SdBannerCarouselTwoRowsComponent } from './banner-carousel-two-rows.component';

@NgModule({
  imports: [NgFor, NgIf, AsyncPipe, SdSwiperComponent, MediaModule, PageComponentModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RosaFormattedResponsiveBannerMultiLineCarouselComponent]: {
          component: SdBannerCarouselTwoRowsComponent,
        },
      },
    }),
  ],
  declarations: [SdBannerCarouselTwoRowsComponent],
})
export class SdBannerCarouselTwoRowsModule {}
